import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    paramData: {
        pageNum: 1,
        pageSize: 20,
        sortType: 'desc',
		sceneType: undefined,
		sceneCategory: undefined,
		sceneSubcategory: undefined,
		timeRange: undefined
    }
}

const reducers = {
    setParamData: (state, action) => ({
        ...state,
        paramData: {
            ...state.paramData,
            ...action.payload
        }
    })
}

const robotQaHighFrequencySlice = createSlice({
    name: 'robotQaHighFrequency',
    initialState,
    reducers
})

export const {
    setParamData
} = robotQaHighFrequencySlice.actions

export const getParamData = state => state.robotQaHighFrequency.paramData

export default robotQaHighFrequencySlice
